import React from "react"
import PropTypes from "prop-types"
import { NavLink } from "react-router-dom"
import { themes } from "ksc-portal-shareable-configs/dist/webpack/webpack-foundation/constants"

const UserSettingsSidebar = ({ moduleData }) => (
  <div className="portal-user-settings-sidebar">
    <NavLink
      className="portal-user-settings-sidebar__links"
      to="/user-settings/general"
    >
      General
    </NavLink>
    <span className="portal-user-settings-sidebar__links">Modules</span>
    {moduleData.map(({ name, path }) => (
      <NavLink
        key={path}
        className="portal-user-settings-sidebar__links ml-3"
        data-testid={`portal-user-setting-sidebar__link-${path.slice(1)}`}
        to={
          themes.map(({ theme }) => theme).indexOf(path.slice(1))
            ? `${path}/user-preferences`
            : `/user-settings/modules${path}`
        }
      >
        {name}
      </NavLink>
    ))}
  </div>
)

UserSettingsSidebar.propTypes = {
  moduleData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    })
  ),
}

UserSettingsSidebar.defaultProps = {
  moduleData: [],
}

export default UserSettingsSidebar
